// eslint-disable-next-line import/prefer-default-export
export const APP_ENVIRONMENT =
  window.__ENV__.REACT_APP_ENVIRONMENT || process.env.REACT_APP_ENVIRONMENT;
